import styled, { css, keyframes } from 'styled-components'

export const MasterLayoutWrapper = styled.div``

const ldsDefault = keyframes`
    0%,
    20%,
    80%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.5);
    }
`

export const Placeholder = styled.div`
    height: 90vh;
    background: white;
`

export const VContainer = styled.div<{ isHaveBackground?: boolean; noPaddingResponsiveContainer?: boolean }>`
    padding: 16px 16px 32px 16px;
    ${({ noPaddingResponsiveContainer }) =>
        noPaddingResponsiveContainer
            ? `
            @media (max-width: 768px) {
                padding: 0;
            }
        `
            : ''}
    ${({ isHaveBackground }) => {
        if (!isHaveBackground) {
            return ''
        }
        return css`
            background-color: #f5f5f5;
        `
    }}
     @media (max-width: 768px) {
        padding: 12px 12px 16px 12px;
    }
`

export const VRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -12px;
    margin-right: -12px;
`

export const VCol = styled.div`
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
    padding: 0 8px;
`

export const MainColFull = styled.div`
    flex-basis: 100%;
    margin-bottom: 10px;
`

export const GlobalLoading = styled.div`
    background: linear-gradient(270deg, #005aff 0%, #001744 100%);
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 999;
    width: 100%;
    left: 0;
`

export const LoadingDefault = styled.div`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    > div {
        position: absolute;
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 50%;
        animation: ${ldsDefault} 1.2s linear infinite;
        &:nth-child(1) {
            animation-delay: 0s;
            top: 37px;
            left: 66px;
        }

        &:nth-child(2) {
            animation-delay: -0.1s;
            top: 22px;
            left: 62px;
        }

        &:nth-child(3) {
            animation-delay: -0.2s;
            top: 11px;
            left: 52px;
        }

        &:nth-child(4) {
            animation-delay: -0.3s;
            top: 7px;
            left: 37px;
        }

        &:nth-child(5) {
            animation-delay: -0.4s;
            top: 11px;
            left: 22px;
        }

        &:nth-child(6) {
            animation-delay: -0.5s;
            top: 22px;
            left: 11px;
        }

        &:nth-child(7) {
            animation-delay: -0.6s;
            top: 37px;
            left: 7px;
        }

        &:nth-child(8) {
            animation-delay: -0.7s;
            top: 52px;
            left: 11px;
        }

        &:nth-child(9) {
            animation-delay: -0.8s;
            top: 62px;
            left: 22px;
        }

        &:nth-child(10) {
            animation-delay: -0.9s;
            top: 66px;
            left: 37px;
        }

        &:nth-child(11) {
            animation-delay: -1s;
            top: 62px;
            left: 52px;
        }

        &:nth-child(12) {
            animation-delay: -1.1s;
            top: 52px;
            left: 62px;
        }
    }
`
